'use client'

import { Box, Skeleton, Stack, styled, Typography } from '@mui/material'

import { colors } from '@/themes/commerce/colors'

export const TextMin = styled(Typography)(({ theme }) => ({
  width: '100%',
  color: theme.palette.text.campaignPrice,
  fontWeight: '700',
  lineHeight: '18px',
}))

export const PriceActiveLine = styled(Typography)(({ theme }) => ({
  fontSize: 20,
  textAlign: 'right',
  width: '100%',
  fontWeight: '700',
  color: theme.palette.text.primary,
}))
export const ProductLabelText = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  justifyContent: 'center',
  border: `1px solid ${theme.palette.border.labelTag}`,
  backgroundColor: theme.palette.background.light, //0078DC
  color: theme.palette.text.labelText,
  borderRadius: '2px',
  minWidth: '160px',
  fontSize: '16px',
  fontWeight: '700',
  padding: '0 10px',
  margin: '-5px 0 ',
  '&.petrolLabel': {
    border: `1px solid ${theme.palette.border.appropriationLabelTag}`,
    color: theme.palette.text.appropriationPrice,
  },
  '&.redLabel': {
    border: `1px solid ${theme.palette.border.campaignLabelTag}`,
    backgroundColor: theme.palette.background.campaignLabel,
    color: theme.palette.text.light,
    minWidth: '80px',
  },
  '&.priceLabelList': {
    fontSize: 14,
    lineHeight: 1.4,
    minWidth: 'min-content',
    maxWidth: '100%',
    whiteSpace: 'nowrap',
  },
  '&.priceLabelList.longLabel ': {
    justifyContent: 'center',
    display: 'block',
    fontSize: 12,
    lineHeight: 1.6,
    minWidth: 'unset',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    position: 'relative',
    zIndex: '1',
    [theme.breakpoints.down('sm')]: { display: 'inline-block' },
  },
}))

export const PriceProductDetails = styled(Stack)(() => ({
  fontSize: '32px',
  fontWeight: '700',
  lineHeight: '30px',
  gap: '8px',
}))
export const PriceProductDetailsStack = styled(Stack)(() => ({
  border: `1px solid ${colors.border.default}`,
  borderRadius: 0.5,
  padding: '16px',
}))

export const PriceProductDetailsSkeletonMain = styled(Skeleton)(() => ({
  marginBlock: '-12px',
  height: 70,
  width: 150,
}))
export const PriceProductDetailsSkeletonSave = styled(Skeleton)(() => ({
  marginBlock: '-6px',
  height: 36,
  width: 60,
}))
export const PriceProductDetailsSkeletonFullPrice = styled(Skeleton)(() => ({
  marginTop: '-10px',
  marginBottom: '-6px',
  height: 40,
  width: 150,
}))
export const PriceProductCartTotal = styled(Skeleton)(() => ({
  height: 32,
  width: 100,
  marginBlock: '-6px',
  alignSelf: 'end',
}))
export const PriceProductCart = styled(Skeleton)(() => ({
  height: 40,
  width: 100,
  marginBlock: '-8px',
  alignSelf: 'end',
}))

export const PriceProductListFullPrice = styled(Skeleton)(() => ({
  height: 24,
  width: 90,
  marginTop: '-2px',
  marginBottom: '-6px',
}))
export const PriceProductList = styled(Skeleton)(() => ({
  height: 36,
  width: 90,
  marginTop: '-6px',
  marginBottom: '-6px',
}))

export const ProductSaveLabelStyle = styled(Typography)(({ theme }) => ({
  background: theme.palette.background.campaignLabel,
  color: theme.palette.text.light,
  fontWeight: 700,
  width: 'max-content',
  paddingInline: '8px',
  borderRadius: '3px',
  '&.productCart': {
    alignSelf: 'flex-start',
    marginInline: '16px',
    position: 'absolute',
    lineHeight: '20px',
    marginTop: '-26px',
  },
  '&.productList': {
    fontSize: '14px',
    paddingInline: '6px',
  },
}))
